var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgVuesaxBoldNotificationFavorite(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "{props.color}",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M19 8a3 3 0 1 1 0-6 3 3 0 0 1 0 6z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.71 9.44c-.08.01-.15.02-.24.03a4.16 4.16 0 0 1-1.7-.15 2.46 2.46 0 0 1-.48-.16c-.15-.06-.31-.14-.45-.22a4.483 4.483 0 0 1-1.78-1.78c-.08-.14-.16-.3-.22-.45a2.46 2.46 0 0 1-.16-.48 4.16 4.16 0 0 1-.15-1.7c.01-.09.02-.16.03-.24.01-.03.01-.06.02-.09A1 1 0 0 0 13.6 3H7.52c-.14 0-.28.01-.41.02-.12.01-.23.02-.35.04-.12.01-.24.03-.35.05-2.41.35-3.95 1.88-4.3 4.3-.02.11-.04.23-.05.35-.02.12-.03.23-.04.35-.01.13-.02.27-.02.41v7.96c0 .14.01.28.02.41.01.12.02.23.04.35.01.12.03.24.05.35.35 2.42 1.89 3.95 4.3 4.3.11.02.23.04.35.05.12.02.23.03.35.04.13.01.27.02.41.02h7.96c.14 0 .28-.01.41-.02.12-.01.23-.02.35-.04.12-.01.24-.03.35-.05 2.41-.35 3.95-1.88 4.3-4.3.02-.11.04-.23.05-.35.02-.12.03-.23.04-.35.01-.13.02-.27.02-.41V10.4a1 1 0 0 0-1.2-.98c-.03.01-.06.01-.09.02zM9.3 17.82c-.64 0-2.43-.88-2.97-2.57h-.01c-.35-1.11.05-2.56 1.32-2.97.58-.19 1.2-.08 1.65.27.45-.35 1.08-.46 1.67-.27 1.27.41 1.67 1.86 1.32 2.97-.53 1.67-2.35 2.57-2.98 2.57z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVuesaxBoldNotificationFavorite);
export default __webpack_public_path__ + "static/media/vuesax-bold-notification-favorite.5c2909bd4e8de70269d5f2d6ee7457c4.svg";
export { ForwardRef as ReactComponent };